import script from "./LoginHome.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginHome.vue?vue&type=script&setup=true&lang=js"

import "./LoginHome.vue?vue&type=style&index=0&id=78bffb7a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78bffb7a"]])

export default __exports__